import { computed } from 'vue';
import { COMPANY, LAWYER } from '../constants/ProfileProductId';

export const useImage = (imageUrlHost: string, imagePath: string, profileProductId: typeof LAWYER | typeof COMPANY) => {
  imagePath = imagePath.replace(/^\//, '');

  const isGenericLogo = new RegExp(/generic/).test(imagePath);

  const computedProfileImagePath = computed(() => {
    return (width: number, height?: number) => {
      return profileProductId === COMPANY
        ? `${imageUrlHost}/cdn-cgi/image/fit=contain,width=${width}${height ? ',height=' + height : ''}/${imagePath}`
        : `${imageUrlHost}/cdn-cgi/image/fit=cover,width=${width},height=${width}/${imagePath}`;
    };
  });

  return {
    computedProfileImagePath,
    isGenericLogo,
  };
};
